// src/components/ui/Navbar.jsx
import React, { useState } from 'react';
import {
  TarotCardsIcon,
  BookIcon,
  ZodiacWheelIcon,
  GraduationCapIcon,
  JournalIcon,
  KeyIcon,
} from './Icons';

const Navbar = ({ onNavigate, currentPage }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { label: 'Tiradas', icon: TarotCardsIcon, destination: 'spreadSelection' },
    { label: 'Guía de Cartas', icon: BookIcon, destination: 'guide' },
    { label: 'Zodiaco', icon: ZodiacWheelIcon, destination: 'zodiac' },
    { label: 'Cursos', icon: GraduationCapIcon, destination: 'courses' },
    { label: 'Mi Diario', icon: JournalIcon, destination: 'journal' },
    { label: 'Mi Cuenta', icon: KeyIcon, destination: 'account' },
  ];

  const handleNav = (dest) => {
    setMenuOpen(false);
    onNavigate(dest);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand" onClick={() => handleNav('landing')}>
        <span className="navbar-logo">🔮</span>
        <span className="navbar-title">Tarot Místico</span>
      </div>

      {/* Desktop nav */}
      <div className="navbar-links">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.destination}
              onClick={() => handleNav(item.destination)}
              className={`navbar-link ${currentPage === item.destination ? 'navbar-link--active' : ''}`}
            >
              <Icon className="navbar-link-icon" aria-hidden="true" />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>

      {/* Mobile hamburger */}
      <button className="navbar-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span><span></span><span></span>
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="navbar-mobile-menu">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.destination}
                onClick={() => handleNav(item.destination)}
                className="navbar-mobile-link"
              >
                <Icon className="navbar-link-icon" aria-hidden="true" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
